import { z } from 'zod';

import { reportRequestSchema, type ReportRequest } from './model';

const serializedReportRequestSchema = z.string().transform((value, context) => {
  try {
    return reportRequestSchema.parse(JSON.parse(value));
  } catch {
    context.addIssue({ code: 'custom', message: 'Invalid serialized report request.' });
    return z.NEVER;
  }
});

const reportShareSettingsValueSchema = z.looseObject({
  filterValueLabels: z.record(z.string(), z.array(z.string())).nullish(),
});

const reportShareSettingsSchema = z.unknown().transform((value) => {
  let normalized = value;
  if (value === null || value === undefined || value === '') normalized = {};
  else if (typeof value === 'string') {
    try {
      normalized = JSON.parse(value) as unknown;
    } catch {
      normalized = {};
    }
  }
  const settings = reportShareSettingsValueSchema.safeParse(normalized);
  return { filterValueLabels: settings.success ? (settings.data.filterValueLabels ?? {}) : {} };
});

export const reportShareResponseSchema = z.object({
  id: z.string(),
  urlHash: z.string(),
  report: serializedReportRequestSchema,
  settings: reportShareSettingsSchema,
  chartReports: z
    .array(serializedReportRequestSchema)
    .nullish()
    .transform((value) => value ?? []),
  publisherId: z
    .string()
    .nullable()
    .optional()
    .transform((value) => value ?? null),
});

export type ReportShare = z.infer<typeof reportShareResponseSchema>;

export interface CreateReportSharePayload {
  report: ReportRequest;
  settings?: string;
  chartReports?: string[];
  publisherId?: string;
}
